// Single owner of the admin route prefix. App.tsx mounts the admin router on
// it; lib/gtag.ts uses it to hard-exclude the admin panel from analytics.
// The path is intentionally obscure — never document it publicly.
if (import.meta.env.PROD && !import.meta.env.SSR && !import.meta.env.VITE_ADMIN_PATH) {
  throw new Error('VITE_ADMIN_PATH must be set as a build env var in production.');
}

export const ADMIN_PATH: string = import.meta.env.VITE_ADMIN_PATH || '/webmastersjwz';
